var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40591 26.7313C9.98268 27.3081 10.8903 27.3525 11.5179 26.8644L11.6687 26.7313L22.4 16L11.6687 5.26858C11.0438 4.64374 10.0308 4.64374 9.40591 5.26858C8.82914 5.84535 8.78477 6.75292 9.27281 7.38059L9.40591 7.53132L17.8733 15.9999L9.40591 24.4686C8.82914 25.0454 8.78477 25.9529 9.27281 26.5806L9.40591 26.7313Z",
    fill: "#1B0076"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.bfb15fdc.svg";
export { ForwardRef as ReactComponent };